import React, { useEffect, useState } from "react";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import { FaTrash } from "react-icons/fa";
import { Btn } from "../../../AbstractElements";
import ReusableCheckBox from "../../Configuration/ReusableComponents/ReusableCheckBox";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { Input } from "reactstrap";

type Props = {
  handleClose?: any;
  handleSubmit?: any;
  setFormData?: any;
  formData?: any;
  modalStatus?: string;
  selectedRow?: any;
  buttonDisable?: boolean;
};

const MediaConfigModalContent = ({
  handleSubmit,
  handleClose,
  setFormData,
  formData,
  modalStatus,
  selectedRow,
  buttonDisable,
}: Props) => {
  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  useEffect(() => {
    if (modalStatus === "Edit" && selectedRow) {
      setFormData({
        media: selectedRow?.MediaId,
        medialabel: selectedRow?.MediaLabel,
        orgunit: selectedRow?.Orgunitid,
        isapp: selectedRow?.IsApp,
      });
    }
  }, [selectedRow]);

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    if (name === "policyYear") {
      const numericValue = value.replace(/[^0-9]/g, ""); // allow only numbers
      if (numericValue.length <= 4) {
        setFormData((prevState: any) => ({
          ...prevState,
          [name]: numericValue,
        }));
      }
      return;
    }

    // Convert specific fields to numbers
    const numericFields = ["monthlyPotentialSales"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormData((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormData((prev: any) => ({ ...prev, media: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  const handleToggleChange = () => {
    setFormData((prev: any) => ({
      ...prev,
      isapp: !prev.isapp,
    }));
  };
  return (
    <>
      {/* First Input */}
      <label style={{ fontWeight: "500" }}>
        Media Label <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Media Label"
        value={formData?.medialabel}
        onChange={(e) => handleInputChange("medialabel", e)}
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />

      {/* Second Input */}
      <RouteDropdown
        options={formattedOrgUnitData || []}
        onChange={(value: any) => {
          handleDropdownSelect("orgunit", value);
        }}
        DropdownHeading="Org Unit"
        asterisk={true}
        value={formData?.orgunit}
        placeholder={"Select Org Unit ..."}
      />

      <div
        className="col-sm-3 form-check form-switch"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "40px",
          justifyContent: "start",
          width: "auto",
          marginLeft: "-30px",
          marginTop: "10px",
        }}
      >
        <label style={{ fontWeight: "500" }}>Is App</label>
        <Input
          type="switch"
          checked={formData?.isapp}
          onChange={handleToggleChange}
          style={{
            marginBottom: "8px",
            minHeight: "1.5em",
            width: "3em",
            cursor: "pointer",
          }}
        />
      </div>
      {/* Hidden file input */}
      <input
        type="file"
        id="mediaUpload"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {/* Upload Button or Preview */}
      {formData.media ? (
        <div
          style={{
            position: "relative",
            marginTop: "10px",
            width: "fit-content",
          }}
        >
          <img
            src={
              formData?.media
                ? `${BASE_URL}${formData?.media}`
                : "https://via.placeholder.com/100?text=No+Image"
            }
            alt="preview"
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
          <span
            onClick={() => {
              setFormData((prevState: any) => ({
                ...prevState,
                media: "",
                mediaFile: null,
              }));

              // ✅ Clear input value
              const fileInput = document.getElementById(
                "mediaUpload"
              ) as HTMLInputElement;
              if (fileInput) fileInput.value = "";
            }}
            style={{
              position: "absolute",
              top: "-8px",
              right: "-8px",
              background: "#fff",
              border: "1px solid #ccc",
              borderRadius: "50%",
              padding: "2px 6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            <FaTrash size={14} color="red" />
          </span>
        </div>
      ) : (
        <Btn
          style={{
            backgroundColor: "#43B9B2",
            color: "white",
            marginTop: "10px",
          }}
          type="button"
          onClick={() => document.getElementById("mediaUpload")?.click()}
        >
          Upload Image
        </Btn>
      )}

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          onClick={handleSubmit}
          disabled={buttonDisable}
        >
          {modalStatus === "Edit" ? "Update" : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </>
  );
};

export default MediaConfigModalContent;
